module.exports = __webpack_public_path__ + "img/product2.22aacb22.png";